(function () {
  'use strict';

  var letterMap = {
    A:'ᚨ',B:'ᛒ',C:'ᚲ',D:'ᛞ',E:'ᛖ',F:'ᚠ',G:'ᚷ',H:'ᚺ',I:'ᛁ',J:'ᛃ',K:'ᚲ',L:'ᛚ',M:'ᛗ',N:'ᚾ',O:'ᛟ',P:'ᛈ',Q:'ᚲᚹ',R:'ᚱ',S:'ᛊ',T:'ᛏ',U:'ᚢ',V:'ᚹ',W:'ᚹ',X:'ᚲᛊ',Y:'ᛁ',Z:'ᛉ','Æ':'ᛇ','Ø':'ᛟ','Å':'ᚨ','Þ':'ᚦ','Ð':'ᛞ','Œ':'ᛟᛖ','Ł':'ᛚ'
  };
  var combinations = {TH:'ᚦ',NG:'ᛜ',PH:'ᚠ',QU:'ᚲᚹ',SH:'ᛊᚺ',CH:'ᚲ',CK:'ᚲ',AA:'ᚨ'};

  function encodeName(value) {
  /* fornvegr-elder-futhark-2026-10-02 (v2). Mirror of scripts/rune_transliteration.py MAPPING_V2. */
  var L = {A:'ᚨ',B:'ᛒ',C:'ᚲ',D:'ᛞ',E:'ᛖ',F:'ᚠ',G:'ᚷ',H:'ᚺ',I:'ᛁ',J:'ᛃ',K:'ᚲ',L:'ᛚ',M:'ᛗ',N:'ᚾ',O:'ᛟ',P:'ᛈ',Q:'ᚲᚹ',R:'ᚱ',S:'ᛊ',T:'ᛏ',U:'ᚢ',V:'ᚹ',W:'ᚹ',X:'ᚲᛊ',Y:'ᛁ',Z:'ᛉ','Æ':'ᛇ','Ø':'ᛟ','Å':'ᚨ','Þ':'ᚦ','Ð':'ᛞ','Œ':'ᛟᛖ','Ł':'ᛚ'};
  var C2 = {TH:'ᚦ',NG:'ᛜ',PH:'ᚠ',QU:'ᚲᚹ',SH:'ᛊᚺ',CH:'ᚲ',CK:'ᚲ',AA:'ᚨ'};
  var SEP = {' ':1,'-':1,"'":1,'’':1};
  var VOW = 'AEIOUYÆØÅ';
  var u = String(value || '').normalize('NFC').toUpperCase(), out = '', i = 0;
  while (i < u.length) {
    var ch = u.charAt(i), nx = u.charAt(i + 1);
    if (SEP[ch]) { out += ' '; i += 1; continue; }
    var ws = i === 0 || !!SEP[u.charAt(i - 1)];
    if (u.substr(i, 3) === 'TTH') { out += 'ᚦ'; i += 3; continue; }
    if (ch === 'C' && (nx === 'E' || nx === 'I' || nx === 'Y')) { out += 'ᛊ'; i += 1; continue; }
    if (ch === 'Ç') { out += 'ᛊ'; i += 1; continue; }
    if (ch === 'Y' && ws && nx && VOW.indexOf(nx) !== -1 && nx !== 'Y') { out += 'ᛃ'; i += 1; continue; }
    var pr = u.slice(i, i + 2);
    if (C2[pr]) { out += C2[pr]; i += 2; continue; }
    if (L[ch]) { out += L[ch]; i += 1; continue; }
    var b = ch.normalize('NFD').replace(/[\u0300-\u036f]/g, '').charAt(0);
    if (L[b]) out += L[b];
    i += 1;
  }
  /* 2026-10-19 double-rune fix: identical runes next to each other in one word are carved once (Olsson -> ᛟᛚᛊᛟᚾ). Runs after letter-to-rune mapping, so CK/CC/X+S and similar also collapse. Names only; date ciphers are not touched. */
  return out.trim().replace(/([\u16A0-\u16FF])\1+/g, '$1');
}

  function init(root, form) {
    if (!root || root.dataset.minnetavleReady === 'true') return;
    var fields = {
      name: root.querySelector('[name="properties[Remembered name]"]'),
      years: root.querySelector('[name="properties[Life dates]"]'),
      relationship: root.querySelector('[name="properties[Relationship]"]'),
      place: root.querySelector('[name="properties[Place]"]'),
      remembered: root.querySelector('[name="properties[Remembered by]"]'),
      runes: root.querySelector('[name="properties[Rune version]"]')
    };
    if (!fields.name || !fields.runes) return;

    function setText(selector, value, fallback) {
      var element = root.querySelector(selector);
      if (element) element.textContent = value || element.getAttribute('data-fallback') || fallback;
    }
    function value(field) { return field ? field.value.trim() : ''; }
    function sync() {
      var name = value(fields.name);
      var runes = encodeName(name);
      var years = value(fields.years).replace(/\s*[–—-]\s*/, ' · ');
      setText('[data-minnetavle-preview="runes"]', runes, 'ᛁᚾᚷᚱᛁᛞ');
      setText('[data-minnetavle-preview="name"]', name.toUpperCase(), 'INGRID SOLBERG');
      setText('[data-minnetavle-preview="years"]', years, '1938 · 2024');
      setText('[data-minnetavle-preview="relationship"]', value(fields.relationship).toUpperCase(), 'MOTHER · GRANDMOTHER');
      setText('[data-minnetavle-preview="place"]', value(fields.place).toUpperCase(), 'TELEMARK, NORWAY');
      setText('[data-minnetavle-preview="remembered"]', value(fields.remembered) ? ((root.querySelector('[data-minnetavle-preview="remembered"]') || {getAttribute: function () { return null; }}).getAttribute('data-prefix') || 'REMEMBERED BY ') + value(fields.remembered).toUpperCase() : '', 'REMEMBERED BY THE SOLBERG FAMILY');
      fields.runes.value = runes;
    }

    Object.keys(fields).forEach(function (key) {
      var field = fields[key];
      if (field && key !== 'runes') {
        field.addEventListener('input', sync);
        field.addEventListener('change', sync);
      }
    });
    if (form) form.addEventListener('submit', sync);
    root.dataset.minnetavleReady = 'true';
    sync();
  }

  window.FornvegrMinnetavle = { encodeName: encodeName, init: init };
})();
